import styled, { css } from 'styled-components';
import { color, size } from './helpers/variables';
import { dynamicFontSize } from './helpers/mixins';

export const Preamble = styled.p`
  ${dynamicFontSize(17, 21, size.small, size.medium)};
  font-weight: 300;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: ${color.black};
  max-width: 620px;
  margin: 1rem auto 0;

  @media screen and (min-width: ${size.medium}px) {
    line-height: 1.56;
    max-width: 80%;
  }

  @media screen and (min-width: ${size.large}px) {
    max-width: 75%;
    margin-bottom: 1rem;
  }

  @media screen and (min-width: ${size.xLarge}px) {
    max-width: 70%;
  }

  ${props =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
      margin: 1rem 0;
      max-width: initial !important;
    `};
`;



// WEBPACK FOOTER //
// ./src/styles/Preamble.js